import styled from 'styled-components';

export const PageWrapStyles = styled.div`
  position: relative;
  width: 100%;
  max-width: 960px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 2px;
  box-sizing: border-box;
  margin: 0 auto;
  overflow: visible;
`;
